import React from 'react'
import { NavigationDots, SocialMedia } from '../components'
import { useInView } from 'react-intersection-observer';

/* * (Component, idName, classNames) viene de c/Componente x ejem: Work,Skills,etc * */
/* * ({ setVisibleSection }) viene de App.js * */
const AppWrap = (Component, idName, classNames) => function HOC({ setVisibleSection }) {
  /* Coordina con Navbar en qué ubicación se encuentra al hacer scroll */
  const { ref } = useInView({
    threshold: 0.5,
    onChange: (inView, entry) => {
      if (inView) {
        setVisibleSection(entry.target.id);

     }
    }
  });

  return (
    <div id={idName} className={`app__container ${classNames} AppWrapjs`} ref={ref} >
        <SocialMedia />
        <div className='app__wrapper app__flex'  >
            <Component/>
            <div className='copyright'>
                <p className='p-text'>@2023 RP Tech</p>
                <p className='p-text'>All rights reserved</p>
            </div>
        </div>
        <NavigationDots active={idName} />
    </div>
  )
}

export default AppWrap;